import Row from 'reactstrap/es/Row';
import Col from 'reactstrap/es/Col';
import 'numeral/locales/ru';
import { ReviewsCount } from '../Badges/reviewsCount';
import { ClientsCount } from '../Badges/ClientsCount';
import { OrdersCount } from '../Badges/OrdersCount';

export function Overview ({ from, to }) {
  return (
	<>
		<div className="d-flex mb-4 align-items-center">
			<h2 className="mr-3 mb-0">
				Обзор
			</h2>
		</div>
		<Row className="mb-5">
			<Col lg={3} xs={6} className="pb-3">
				<OrdersCount from={from} to={to} title="Заказы на сайте" color="green" />
			</Col>
			<Col lg={3} xs={6} className="pb-3">
				<ClientsCount from={from} to={to} type="total" caption="Новых клиентов" color="brown" />
			</Col>
			<Col lg={3} xs={6} className="pb-3">
				<OrdersCount from={from} to={to} title="От постоянных клиентов" type="regular" color="purple" />
			</Col>
			<Col lg={3} xs={6} className="pb-3">
				<OrdersCount from={from} to={to} title="От новых клиентов" type="new" color="blue" />
			</Col>
			{/* <Col lg={3} xs={6} className="pb-3">
				<OrdersCount from={from} to={to} title="Заказов в AmoCrm" type="amo" color="brown" />
			</Col> */}
			<Col lg={3} xs={6} className="pb-3">
				<ReviewsCount from={from} to={to} color="brown" />
			</Col>
		</Row>
	</>

  );
}
